import { useParams } from 'react-router-dom';

/**
 * The pen URL (`/c/:clientId/location/:locationId/pen/:cageId`) the current route sits under,
 * built from the raw URL params so it keeps whatever the address bar holds.
 *
 * Pen modules (health, reports) build their redirects and tab links on it: react-router 7 has
 * no `useRouteMatch().url`, and inside a splat route a relative path resolves against the whole
 * URL, splat included, not against the route's own path.
 */
export function usePenUrl(): string {
    const { clientId, locationId, cageId } = useParams();
    return `/c/${clientId ?? ''}/location/${locationId ?? ''}/pen/${cageId ?? ''}`;
}
